module.exports = __webpack_public_path__ + "media/images/icons/v2/dots-horizontal-119ffdeca9e0d99ef99182bcd8c63d17.svg";